/**
 * Tech Tool Line Card — Directory Search + Category Filter
 * File: assets/lc-directory.js
 * Vanilla JS, no dependencies. WCAG 2.1 AA aria-live count, aria-pressed chips.
 * v2: single-row chips, clear button, active count in chip, toggle deselect.
 */

(function () {
  'use strict';

  function init() {
    var searchInput   = document.getElementById('lc-dir-search');
    var rows          = document.querySelectorAll('[data-lc-cat]');
    var groups        = document.querySelectorAll('[data-lc-letter]');
    var countNum      = document.getElementById('lc-dir-count-num');
    var countWrap     = document.getElementById('lc-dir-count-wrap');
    var emptyEl       = document.getElementById('lc-dir-empty');
    var chips         = document.querySelectorAll('[data-lc-chip]');
    var clearBtn      = document.getElementById('lc-dir-clear');
    var chipsContainer = document.querySelector('.lc-filter-chips');

    if (!rows.length) return;

    var activeChip = 'all';

    // Snapshot original chip order so we can restore it on clear
    var originalOrder = Array.from(chips);

    // Move active chip to position 1 (after "All"); restore order when clearing
    function syncChipOrder(val) {
      if (!chipsContainer) return;
      // Always restore to original order first
      originalOrder.forEach(function (chip) { chipsContainer.appendChild(chip); });
      if (val !== 'all') {
        var allEl    = chipsContainer.querySelector('[data-lc-chip="all"]');
        var activeEl = chipsContainer.querySelector('[data-lc-chip="' + val + '"]');
        if (allEl && activeEl && activeEl !== allEl) {
          allEl.after(activeEl);
          // Scroll chip row to start so active chip is visible
          chipsContainer.scrollLeft = 0;
        }
      }
    }

    // Set active chip, reset all chip labels to base text
    function setActiveChip(val) {
      activeChip = val;
      chips.forEach(function (c) {
        var isActive = c.getAttribute('data-lc-chip') === activeChip;
        c.classList.toggle('is-active', isActive);
        c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        // Reset to clean base label
        var baseLabel = c.getAttribute('data-lc-label');
        if (baseLabel) c.textContent = baseLabel;
      });
    }

    // Append visible count to the active (non-all) chip label
    function updateChipCount(visible) {
      if (activeChip === 'all') return;
      chips.forEach(function (c) {
        if (c.getAttribute('data-lc-chip') === activeChip) {
          var baseLabel = c.getAttribute('data-lc-label') || c.textContent;
          c.textContent = baseLabel + ' · ' + visible;
        }
      });
    }

    function applyFilters() {
      var query      = searchInput ? searchInput.value.toLowerCase().trim() : '';
      var visible    = 0;
      var isFiltered = activeChip !== 'all' || query.length > 0;

      rows.forEach(function (row) {
        var cat    = row.getAttribute('data-lc-cat') || '';
        var nameEl = row.querySelector('.lc-dir-row__brand-link') || row;
        var descEl = row.querySelector('.lc-dir-row__desc');
        var name   = nameEl.textContent.toLowerCase();
        var desc   = descEl ? descEl.textContent.toLowerCase() : '';

        var chipMatch   = activeChip === 'all' || cat === activeChip;
        var searchMatch = !query || name.indexOf(query) !== -1 || desc.indexOf(query) !== -1;
        var show        = chipMatch && searchMatch;

        row.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      // Hide empty letter groups
      groups.forEach(function (group) {
        var hasVisible = false;
        group.querySelectorAll('[data-lc-cat]').forEach(function (r) {
          if (r.style.display !== 'none') hasVisible = true;
        });
        group.style.display = hasVisible ? '' : 'none';
      });

      // Count display — visibility preserves search-row layout width (no reflow there)
      if (countNum) countNum.textContent = visible;
      if (countWrap) countWrap.style.visibility = isFiltered ? 'visible' : 'hidden';

      // Chip count label
      updateChipCount(visible);

      // Clear button — desktop only (≤640px hides it via this check).
      // On mobile the active chip shows a CSS × and tap-to-deselect handles clearing,
      // so the button would just eat flex space. On desktop it's a useful secondary affordance.
      if (clearBtn) {
        var isMobileWidth = window.innerWidth <= 640;
        clearBtn.style.display = (!isMobileWidth && activeChip !== 'all') ? 'inline-flex' : 'none';
      }

      // Empty state
      if (emptyEl) emptyEl.style.display = visible > 0 ? 'none' : '';
    }

    // Search input
    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }

    // Chip clicks — toggle: clicking an active non-all chip resets to all
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var clicked = this.getAttribute('data-lc-chip');
        var next    = (clicked === activeChip && clicked !== 'all') ? 'all' : clicked;
        setActiveChip(next);
        syncChipOrder(next);
        if (searchInput) searchInput.value = '';
        applyFilters();
      });
    });

    // Clear button — return focus to "All" chip so keyboard users aren't stranded
    // on a display:none element (WCAG 2.4.3 Focus Order)
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        setActiveChip('all');
        syncChipOrder('all');
        if (searchInput) searchInput.value = '';
        applyFilters();
        var allChip = chipsContainer && chipsContainer.querySelector('[data-lc-chip="all"]');
        if (allChip) allChip.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
